import React from 'react';
import PropTypes from 'prop-types';
import classes from './ClearIndicatorPart.module.scss';
import { Icon, Button } from '../../../Elements';

const ClearIndicatorPart = props => {
  const { clearValue, isFocused } = props;
  if (!isFocused) {
    return null;
  }
  return (
    <Button
      className={classes.clear}
      onClick={() => clearValue()}
      aria-label={`clear select`}
      tabIndex="-1"
    >
      <Icon
        icon={'closeCircle'}
        className={classes.icon}
        size="16px"
        aria-hidden="true"
      />
    </Button>
  );
};

ClearIndicatorPart.propTypes = {
  clearValue: PropTypes.func.isRequired,
  isFocused: PropTypes.bool,
  selectProps: PropTypes.object
};

export default ClearIndicatorPart;
